import React, { useCallback } from 'react';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';

function NotSupportedModal({ open }) {

  return (
    <Modal
      open={open}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={{ bgcolor: 'background.paper', p: 2, m: 2, mt: 5,  }}>
        <Typography sx={{ fontWeight: 'bold' }}>
          {t('eos.landing_page.text.not_supported_browser.title')}
        </Typography>
        <Typography sx={{ mt: 2 }}>
          {t('eos.landing_page.text.not_supported_browser.text')}
        </Typography>
      </Box>
    </Modal>
  );
}

export default NotSupportedModal;
